import { TaxData } from "@/app/[locale]/dashboard/common/claim/tax-data";
import { Button } from "@/components/ui/button";
import {
    CredenzaBody,
    CredenzaDescription,
    CredenzaFooter,
    CredenzaHeader,
    CredenzaTitle,
} from "@/components/ui/credenza";
import { useScopedI18n } from "@/locales/client";

export function EditVat({ goBack }: { goBack: () => void }) {
    const t = useScopedI18n("paymentDialogs.common.editVat");

    return (
        <>
            <CredenzaHeader>
                <CredenzaTitle>{t("title")}</CredenzaTitle>
                <CredenzaDescription>{t("description")}</CredenzaDescription>
            </CredenzaHeader>
            <TaxData
                onSuccess={goBack}
                body={(children) => <CredenzaBody>{children}</CredenzaBody>}
                footer={(children) => (
                    <CredenzaFooter>
                        <Button onClick={goBack} variant="outline">
                            {t("buttons.goBack")}
                        </Button>
                        {children}
                    </CredenzaFooter>
                )}
            />
        </>
    );
}
